import { Theme } from '@interfaces/global';
import { LeadDetails } from '@utils/backend-api/users';
import { FormLocation } from '@utils/enums';
import { LeadType } from '@utils/types';

export const GDPR_FIELD_LABEL =
  'Receive breaking news, relevant articles, and special event invites from The Information';

export interface EmailLeadCaptureProps {
  articleId?: number;
  briefingGuid?: string;
  buttonClassName?: string;
  buttonText: string;
  expandableOathButtonsClassName?: string;
  formClassName?: string;
  formLocation: FormLocation;
  gdpr?: boolean;
  gdprClassName?: string;
  gdprFormClassName?: string;
  includeSignInOption?: boolean;
  inputClassName?: string;
  inputWrapperClassName?: string;
  isNewsletterHeader?: boolean;
  isPro?: boolean;
  isRight?: boolean;
  isVertical?: boolean;
  isVerticalMobile?: boolean;
  leadDetails?: LeadDetails;
  leadType?: LeadType;
  newsletterIds?: number[];
  oauthButtonsClassName?: string;
  oauthRedirectToOnSuccess?: string;
  redirectToOnSuccess: string;
  shareGuid?: string;
  subscribeToAllNewsletters?: boolean;
  signInOptionClass?: string;
  skipVerifyNewEmail?: boolean;
  theme?: Theme;
  toastMessageOnSuccess?: string;
  unlockContent?: boolean;
  withOauth?: boolean;
  withOnlyOauthExpandable?: boolean;
}

export interface EmailLeadForm {
  email: string;
  gdprOptIn?: boolean;
}
